<template>
  <div>
    <!-- 列表 -->
    <el-table
    :data="list_data"
    highlight-current-row
    border
    max-height="500"
    >
      <el-table-column
      v-for="item in new_field_list"
      :key="item"
      align="center"
      :prop="item"
      :label="item"
      ></el-table-column>
    </el-table>
    <el-button
    style="margin-top: 10px;"
    type="primary"
    icon="el-icon-download"
    @click="exportExcel"
    >导出Excel</el-button>
  </div>
</template>

<script>
  export default {
    data() {
      return{
        //参数
        viewFlag:'',
        messageId:'',
        fileName:'',
        //列表
        list_data:[],
        new_field_list:[]
      }
    },
    created() {
      let that=this
      that.publicAjax.axios_set()
      that.viewFlag=window.location.href.split("?")[1].
      split("&")[0].split("=")[1]
      that.messageId=window.location.href.split("?")[1].
      split("&")[1].split("=")[1]
      that.fileName=decodeURIComponent(window.location.href.split("?")[1].
      split("&")[2].split("=")[1])
      //获取列表展示字段
      that.get_field()
    },
    methods:{
      //获取列表展示字段
      get_field(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/wms/alert/fields/'+that.viewFlag+'?dbName='+that.fileName
        }).then(data=>{
          if(data.data.success==true){
            that.new_field_list=data.data.data
            //获取列表
            that.get_query()
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //获取列表
      get_query(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/wms/alert/data/'+that.viewFlag+'/'+that.messageId+'?showFields='+that.new_field_list+'&dbName='+that.fileName
        }).then(data=>{
          if(data.data.success==true){
            that.list_data=data.data.data
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //导出Excel
      exportExcel(){
        const loading=this.$loading({
          lock:true,
          text:'正在拼命导出，请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.3)'
        })
        let that=this
        let url='/wms/alert/export/'+that.viewFlag+'/'+that.messageId+'?showFields='+that.new_field_list+'&dbName='+that.fileName
        url=encodeURI(url)
        that.$axios({
          url:that.publicAjax.extra_path+url,
          method:'get',
          responseType:'blob'
        }).then(data=>{
          if(data.data.success==false){
            that.$message.warning(data.data.message)
            loading.close()
          }else{
            let link=document.createElement('a')
            link.href=window.URL.createObjectURL(new Blob([data.data], {type:"application/vnd.ms-excel"}))
            link.style.display='none'
            let fname=that.fileName+'.xls'
            link.setAttribute('download',fname)
            document.body.appendChild(link)
            link.click()
            URL.revokeObjectURL(link.href)
            document.body.removeChild(link)
            loading.close()
          }
        })
      }
    }
  }
</script>

<style scoped="scoped">

</style>



// WEBPACK FOOTER //
// src/components/get_file.vue